import { render, staticRenderFns } from "./FootBar.vue?vue&type=template&id=19eb47d8&scoped=true"
import script from "./FootBar.vue?vue&type=script&lang=js"
export * from "./FootBar.vue?vue&type=script&lang=js"
import style0 from "./FootBar.vue?vue&type=style&index=0&id=19eb47d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19eb47d8",
  null
  
)

export default component.exports